import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

type SectionHeadingProps = HTMLAttributes<HTMLHeadingElement> & {
    children?: ReactNode;
};

const Container = styled.h2`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 26px;
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #444444;
`;

const SectionHeading: FunctionComponent<SectionHeadingProps> = ({
    children,
    ...props
}) => {
    return (
        <Container {...props}>{children}</Container>
    );
};

export default SectionHeading;